import { useEffect } from 'react'
import { useToaster } from 'rsuite'
import { setToaster } from '@/components/shared/toaster'

/**
 * Provider component that sets up the global toaster for the entire app
 * This should be used once at the app level
 */
const ToasterProvider = ({ children }) => {
  const toaster = useToaster()

  useEffect(() => {
    setToaster(toaster)
  }, [toaster])

  return children
}

export default ToasterProvider
